export default __webpack_public_path__ + "static/media/25.37e98fa1.jpg";